export default __webpack_public_path__ + "static/team-member-80b2eddec5c0be042c2221ea55501d0d.jpg";